<template>
    <div class="column is-4-desktop">
        <form>
            <div class="field">
                <label class="label">Phone</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-bind:disabled="!isAdmin && !isAffiliate" v-model="user.details.phone"
                           v-on:keyup="updateUserDetails"
                           v-bind:class="{ 'is-danger': error.errors.phone }"
                           class="input"
                           type="number"
                           placeholder="Phone"
                           required=""
                           autofocus="">
                    <span class="icon is-left">
                        <i class="fas fa-phone"></i>
                    </span>
                    <p v-if="error.errors.phone" class="help is-danger">{{ error.errors.phone[0] }}</p>
                </div>
            </div>
            <div class="field">
                <label class="label">Type</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <div class="select is-fullwidth">
                        <select v-bind:disabled="!isAdmin && !isAffiliate" v-model="user.details.type"
                                v-on:change="updateUserDetails"
                                v-bind:class="{ 'is-danger': error.errors.type }">
                            <option :value="this.$userTypeIndividual">Individual</option>
                            <option :value="this.$userTypeProfessional">Professional</option>
                            <option :value="this.$userTypeOther">Other</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-user"></i>
                    </span>
                    <p v-if="error.errors.type" class="help is-danger">{{ error.errors.type[0] }}</p>
                </div>
            </div>
            <div class="field">
                <label class="label">Company</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-bind:disabled="!isAdmin && !isAffiliate" v-model="user.details.company"
                           v-on:keyup="updateUserDetails"
                           v-bind:class="{ 'is-danger': error.errors.company }"
                           class="input"
                           type="text"
                           required=""
                           placeholder="Company name">
                    <span class="icon is-left">
                        <i class="fas fa-briefcase"></i>
                    </span>
                    <p v-if="error.errors.company" class="help is-danger">{{ error.errors.company[0] }}</p>
                </div>
            </div>
            <div class="field">
                <label class="label">Country</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <div class="select is-fullwidth" v-bind:class="{ 'is-danger': error.errors.country }">
                        <select v-bind:disabled="!isAdmin && !isAffiliate" v-model="user.details.country"
                                v-on:change="updateUserDetails">
                            <option value="" hidden disabled>Country</option>
                            <option v-for="country in countries">{{ country.name }}</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-globe"></i>
                    </span>
                    <p v-if="error.errors.country" class="help is-danger">{{ error.errors.country[0] }}</p>
                </div>
            </div>
            <div class="field">

                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <label class="label">
                    <input v-bind:disabled="!isAdmin && !isAffiliate" v-model="checked"
                           v-on:change="sendEmail"
                           v-bind:class="{ 'is-danger': error.errors.sand_email }"
                           type="checkbox"
                           required=""
                           autofocus=""


                    >
                         Send automated email</label>
                    <p v-if="error.errors.sand_email" class="help is-danger">{{ error.errors.sand_email[0] }}</p>
                </div>
            </div>
            <div class="field" v-if="false">
                <label class="label">Sales Staff</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <div class="select is-fullwidth">
                        <select v-model="sales_staff"
                                v-on:change="updateUserSaleStaff"
                                v-bind:class="{ 'is-danger': error.errors.type }">
                            <option :value="null">No Sales Staff</option>
                            <option v-for="option of options" :value="option.id">{{ option.text }}</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-user"></i>
                    </span>
                    <p v-if="error.errors.type" class="help is-danger">{{ error.errors.type[0] }}</p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import apiUsers from '../../../api/apiUsers'
    import axios from 'axios'
    export default {
        props: ['user'],
        data() {
            return {
                sales_staff: this.user.sales_staff ? this.user.sales_staff.id : null,
                options: [],
                countries: [],
                isLoading: false,
                checked:false,
                send_mail_value:0,
                send_email_value:false,
                error: {
                    message: '',
                    errors: {
                        phone: '',
                        type: '',
                        company: '',
                        country: '',
                        send_mail:''
                    }
                }
            }
        },
        methods: {
            updateUserDetails () {
                setTimeout(() => {
                    this.isLoading = true
                    apiUsers
                        .userDetailsUpdateRequest(this.getDetails)
                        .then((response) => {
                            this.isLoading = false

                        })
                        .catch((error) => {
                            this.isLoading = false
                        })
                }, 1000)
            },
            setSelectOptions (users) {
                let list = []

                users.forEach(function(element) {
                    list.push({
                        id: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            updateUserSaleStaff() {
                this.isLoading = true
                let userId = this.user.id
                let user = {
                    email: this.user.email,
                    name: this.user.name,
                    role: this.user.role,
                    sales_staff_id: this.sales_staff

                }
                apiUsers
                    .userUpdateRequest(userId, user)
                    .then((response) => {
                        location.reload()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            sendEmail(){

                setTimeout(() => {

                    let userChack = {
                        email: this.user.email,
                        name: this.user.name,
                        role: this.user.role,
                        sales_staff_id: this.sales_staff,
                        send_email:this.checked
                    }

                    apiUsers
                        .userDetailsUpdateRequest(userChack)

                }, 500)
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        },
        computed: {
            getDetails: function () {
                return this.$store.getters.getDetails
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            }

        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        },
        created(){
            apiUsers
                .salesStaffListRequest()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserDetails.vue